const price = (state = null, action) => {
  switch (action.type) {
    case "GET_TOTAL":
      return action.payload;
    default:
      return state;
  }
};

export default price;
